import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PropertySafetyTwoToneSvg from "@ant-design/icons-svg/es/asn/PropertySafetyTwoTone";
import AntdIcon from "../components/AntdIcon";
var PropertySafetyTwoTone = function PropertySafetyTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PropertySafetyTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PropertySafetyTwoTone.displayName = 'PropertySafetyTwoTone';
}
export default /*#__PURE__*/React.forwardRef(PropertySafetyTwoTone);